import React, { useEffect, useState } from "react";
import { ref as ref_database, onValue } from "firebase/database";
import { rtdb } from "../utility/firebase";
import Moment from "react-moment";
import "moment/locale/zh-hk";
import { useNavigate } from "react-router-dom";
import ProfilePic from "../resource/profile_pic.png";
import { Badge, Button, Modal } from "react-bootstrap";
import ChatRoomModal from "./ChatRoomModal";
import ChatRoomDropDown from "./ChatRoomDropDown";
import { myFetchPost, apiUrl, webSiteUrl, getMobileOperatingSystem, imageHost, getCookie } from "../utility";
import "../css/ChatRoomHeader.css";

const ChatRoomHeader = (props) => {
  const {
    listItemId,
    currentUser,
    itemData,
    setItemData,
    itemId,
    currentChatRoom,
    currentChatRoomId,
    chatUserData,
    unReadCounter,
    setIsSendingMessage,
    offer,
    chatRoomMeta,
    showWarningModal,
    showOfferModalReady,
  } = props;

  const navigate = useNavigate();

  /* online presence */
  const [presence, setPresence] = useState({});

  /* offer */
  const [offerPrice, setOfferPrice] = useState("");

  /* reviews */
  const [reviewText, setReviewText] = useState("");
  const [reviewStar, setReviewStar] = useState(5);

  /* various modal state */
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [showCancelOfferModal, setShowCancelOfferModal] = useState(false);
  const [showAcceptOfferModal, setShowAcceptOfferModal] = useState(false);
  const [showRejectOfferModal, setShowRejectOfferModal] = useState(false);
  const [showWriteReviewModal, setShowWriteReviewModal] = useState(false);
  const [showReserveModal, setShowReserveModal] = useState(false);
  const [showSoldOutModal, setShowSoldOutModal] = useState(false);

  const [offerPropsHandled, setOfferPropsHandled] = useState(false);

  /* dialog */
  const [dialogMessage, setDialogMessage] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  /* errors */
  const [reviewTextError, setReviewTextError] = useState(false);
  const [offerError, setOfferError] = useState(false);

  /* cookie */
  const [deviceId, setDeviceId] = useState("");

  useEffect(() => {
    const cookieValue = getCookie("dcff_psid");
    if (cookieValue) {
      setDeviceId(cookieValue);
    }
  }, []);


  useEffect(() => {
    if (
      offer != null &&
      itemData.offerAllowed &&
      chatRoomMeta.chat_disabled == false &&
      showWarningModal == false &&
      showOfferModalReady == true &&
      offerPropsHandled == false
    ) {
      setOfferPropsHandled(true);
      if (currentChatRoom) {
        if (
          currentChatRoom.lastOffer?.offeredStatus == "" ||
          currentChatRoom.lastOffer?.offeredStatus == null ||
          currentChatRoom.lastOffer?.offeredStatus == "rejected"
        ) {
          setShowOfferModal(true);
        } else {
          setShowOfferModal(false);
        }
      } else {
        setShowOfferModal(true);
      }
    }
  }, [
    offer != null,
    itemData,
    chatRoomMeta,
    showWarningModal,
    showOfferModalReady,
    currentChatRoom,
    offerPropsHandled,
  ]);

  useEffect(() => {
    if (chatUserData?.uid > 0) {
      /* also listen to online indicator & last presence */
      const presenceRef = ref_database(rtdb, "/status/" + chatUserData.uid);
      const unPresence = onValue(presenceRef, (snapshot) => {
        const data = snapshot.val();
        setPresence(data);
      });
      return () => {
        setPresence({});
        unPresence();
      };
    }
  }, [chatUserData?.uid]);

  useEffect(() => {
    return () => {
      setPresence({});
    };
  }, [currentChatRoomId]);

  const handleNewOffer = async () => {
    if (offerPrice == "") {
      //alert("請輸入你的出價");
      setOfferError("請輸入你的出價");
    } else if (isNaN(offerPrice)) {
      //alert("請輸入正確的出價");
      setOfferError("請輸入正確的出價");
    } else {
      try {
        setIsSendingMessage(true);
        /* if  e got itemId, we need to create the chatRoom first */
        const token = await currentUser.getIdToken();
        if (currentChatRoomId) {
          const offerRequestData = {
            chatRoomId: currentChatRoomId,
            itemId: currentChatRoom.itemInfo.itemId,
            offerPrice: offerPrice,
            text: "",
            targetUserId: currentChatRoom.members?.find(
              (uid) => uid != currentUser.uid
            ),
            platform: getMobileOperatingSystem(),
          };

          const res = await myFetchPost(
            `${apiUrl}/offer/makeoffer`,
            offerRequestData,
            {
              Authorization: "Bearer " + token,
            }
          );
        } else {
          const requestData = {
            itemID: itemId,
            platform: getMobileOperatingSystem(),
            deviceId: deviceId,
          };
          const res = await myFetchPost(
            `${apiUrl}/chat/createroom`,
            requestData,
            {
              Authorization: "Bearer " + token,
            }
          );

          if (res.result == "failed") {
            if (res.message) {
              throw new Error(res.message);
            }
            throw new Error("未能開始對話");
          }          

          const offerRequestData = {
            chatRoomId: res.chatRoomId,
            itemId: itemId,
            offerPrice: offerPrice,
            text: "",
            targetUserId: res.targetUserId,
            platform: getMobileOperatingSystem(),
          };

          const data = await myFetchPost(
            `${apiUrl}/offer/makeoffer`,
            offerRequestData,
            {
              Authorization: "Bearer " + token,
            }
          );

          /* if we are in create chat mode, we replace the url */
          navigate(`/${res.chatRoomId}`, { replace: true });
        }
        setOfferPrice("");
        setIsSendingMessage(false);
        setShowOfferModal(false);
      } catch (error) {
        setOfferPrice("");
        setIsSendingMessage(false);
        setShowOfferModal(false);
        setDialogMessage(error.message);
        setShowDialog(true);
      }
    }
  };

  const handleCancelOffer = async (offerPrice) => {
    try {
      setIsSendingMessage(true);
      const token = await currentUser.getIdToken();

      const requestData = {
        chatRoomId: currentChatRoomId,
        itemId: currentChatRoom.itemInfo.itemId,
        offerPrice: offerPrice,
        text: "",
        targetUserId: currentChatRoom.members?.find(
          (uid) => uid != currentUser.uid
        ),
        platform: getMobileOperatingSystem(),
      };
      const res = await myFetchPost(
        `${apiUrl}/offer/canceloffer`,
        requestData,
        {
          Authorization: "Bearer " + token,
        }
      );
      setOfferPrice("");
      setIsSendingMessage(false);
      setShowCancelOfferModal(false);
    } catch (error) {
      setOfferPrice("");
      setIsSendingMessage(false);
      setShowCancelOfferModal(false);
      alert("未能完成你的請求, 請再試!");
    }
  };

  const handleRejectOffer = async (offerPrice) => {
    try {
      setIsSendingMessage(true);
      const token = await currentUser.getIdToken();

      const requestData = {
        chatRoomId: currentChatRoomId,
        itemId: currentChatRoom.itemInfo.itemId,
        offerPrice: offerPrice,
        text: "",
        targetUserId: currentChatRoom.members?.find(
          (uid) => uid != currentUser.uid
        ),
        platform: getMobileOperatingSystem(),
      };

      const res = await myFetchPost(
        `${apiUrl}/offer/rejectoffer`,
        requestData,
        {
          Authorization: "Bearer " + token,
        }
      );

      setIsSendingMessage(false);
      setShowRejectOfferModal(false);
    } catch (error) {
      setIsSendingMessage(false);
      setShowRejectOfferModal(false);
      alert("未能完成你的請求, 請再試!");
    }
  };

  const handleAcceptOffer = async (offerPrice) => {
    try {
      setIsSendingMessage(true);
      const token = await currentUser.getIdToken();

      const requestData = {
        chatRoomId: currentChatRoomId,
        itemId: currentChatRoom.itemInfo.itemId,
        offerPrice: offerPrice,
        text: "",
        targetUserId: currentChatRoom.members?.find(
          (uid) => uid != currentUser.uid
        ),
        platform: getMobileOperatingSystem(),
      };

      const res = await myFetchPost(
        `${apiUrl}/offer/acceptoffer`,
        requestData,
        {
          Authorization: "Bearer " + token,
        }
      );

      setIsSendingMessage(false);
      setShowAcceptOfferModal(false);
    } catch (error) {
      setIsSendingMessage(false);
      setShowAcceptOfferModal(false);
      alert("未能完成你的請求, 請再試!");
    }
  };

  const handleWriteReview = async () => {
    if (reviewText.length == 0) {
      //alert("請輸入交易評價");
      setReviewTextError("請輸入交易評價");
    } else if (reviewStar < 0 || reviewStar > 5) {
      //alert("請選擇整體評分");
      setReviewTextError("請選擇整體評分");
    } else {
      try {
        setIsSendingMessage(true);
        const token = await currentUser.getIdToken();

        const requestData = {
          chatRoomId: currentChatRoomId,
          itemId: currentChatRoom.itemInfo.itemId,
          reviewText: reviewText,
          reviewStar: reviewStar,
          targetUserId: currentChatRoom.members?.find(
            (uid) => uid != currentUser.uid
          ),
          platform: getMobileOperatingSystem(),
        };

        const res = await myFetchPost(
          `${apiUrl}/chat/writereview`,
          requestData,
          {
            Authorization: "Bearer " + token,
          }
        );

        if (res.result != "success") {
          alert(res.message);
        }

        setIsSendingMessage(false);
        setShowWriteReviewModal(false);
      } catch (error) {
        setIsSendingMessage(false);
        setShowWriteReviewModal(false);
        alert("未能完成你的請求, 請再試!");
      }
    }
  };

  const handleReserve = async () => {
    try {
      setIsSendingMessage(true);
      const token = await currentUser.getIdToken();

      const requestData = {
        chatRoomId: currentChatRoomId,
        itemId: currentChatRoom.itemInfo.itemId,
        targetUserId: currentChatRoom.members?.find(
          (uid) => uid != currentUser.uid
        ),
        platform: getMobileOperatingSystem(),
      };

      const data = await myFetchPost(`${apiUrl}/item/reserve`, requestData, {
        Authorization: "Bearer " + token,
      });

      if (data.result == "success") {
        setItemData(data.itemInfo);

        setIsSendingMessage(false);
        setShowReserveModal(false);
      } else {
        throw new Error("Reserve not successful");
      }
    } catch (error) {
      setIsSendingMessage(false);
      setShowReserveModal(false);
      alert("未能完成你的請求, 請再試!");
    }
  };

  const handleSoldOut = async () => {
    try {
      setIsSendingMessage(true);
      const token = await currentUser.getIdToken();

      const requestData = {
        chatRoomId: currentChatRoomId,
        itemId: currentChatRoom.itemInfo.itemId,
        targetUserId: currentChatRoom.members?.find(
          (uid) => uid != currentUser.uid
        ),
        platform: getMobileOperatingSystem(),
      };

      const data = await myFetchPost(`${apiUrl}/item/soldout`, requestData, {
        Authorization: "Bearer " + token,
      });
      if (data.result == "success") {
        setItemData(data.itemInfo);

        setIsSendingMessage(false);
        setShowSoldOutModal(false);
      } else {
        throw new Error("mark as sold not successful");
      }
    } catch (error) {
      setIsSendingMessage(false);
      setShowSoldOutModal(false);
      alert("未能完成你的請求, 請再試!");
    }
  };

  let tradingRating = null;
  if (chatUserData.rating > 0) {
    tradingRating = (
      <span className="tradingRating">({chatUserData.rating})</span>
    );
  }
  let facebookIcon = null;
  if (chatUserData.facebook) {
    facebookIcon = (
      <span className="facebookVerified">
        <i className="bi bi-facebook"></i>
      </span>
    );
  }
  let phoneVerifedIcon = null;
  if (chatUserData.verified) {
    phoneVerifedIcon = (
      <span className="phoneVerified">
        <i className="bi bi-telephone-fill"></i>
      </span>
    );
  }
  let newUserIcon = null;
  if (chatUserData.newuser) {
    newUserIcon = <span className="newUserIcon">新</span>;
  }

  let isOnlineText =
    presence?.last_changed > 0 ? (
      <>
        最後上線&nbsp;<Moment fromNow>{presence?.last_changed}</Moment>
      </>
    ) : (
      <div>&nbsp;</div>
    );
  if (presence?.state == "online") {
    isOnlineText = (
      <>
        <div className="onlineNowIcon"></div>
        在線
      </>
    );
  }

  const currentMembers = currentChatRoom?.membersInfo[chatUserData.uid];

  let offerRow = null;
  if (currentChatRoom == null) {
    if (itemData.offerAllowed) {
      offerRow = (
        <div className="offerRow">
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              setShowOfferModal(true);
            }}
          >
            我要出價
          </Button>
        </div>
      );
    }
    //} else if (chatRoomMeta.is_feedbacked) {
  } else {
    if (currentUser.uid == currentChatRoom.createdUser) {
      /* I am initiating the chat */
      if (currentChatRoom.reviewStatus?.createdUserReviewStatus && currentChatRoom.reviewStatus?.itemOwnerReviewStatus) {
        offerRow = (
          <div style={{ color: '#198754', fontSize: '14px', fontWeight: 600 }}>
            已成交及評價
          </div>
        );
      } else if (currentChatRoom.lastOffer?.offeredStatus == "offered") {
        offerRow = (
          <>
            已出價 HK${currentChatRoom.lastOffer?.offeredPrice}&nbsp;
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowCancelOfferModal(true);
              }}
            >
              取消出價
            </Button>
          </>
        );
      } else if (currentChatRoom.lastOffer?.offeredStatus == "accepted") {
        let reviewButton = null;
        if (currentChatRoom.reviewStatus?.createdUserReviewStatus) {
          reviewButton = (
            <div style={{ color: '#198754', fontSize: '14px', fontWeight: 600 }}>
              我已評價
            </div>
          );
        } else {
          /* 30 days write review limit */
          /*
          if (
            Math.floor(Date.now() / 1000) <
            currentChatRoom.lastOffer?.offerUpdatedTime.seconds + 86400 * 30
          ) {
          */
          reviewButton = (
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                setShowWriteReviewModal(true);
              }}
              className="offerButton"
            >
              寫交易評價
            </Button>
          );
          /*}*/
        }
        offerRow = (
          <>
            {`已成交 HK$${currentChatRoom.lastOffer?.offeredPrice} `}&nbsp;
            {reviewButton}
          </>
        );
      } else {
        if (itemData.offerAllowed) {
          offerRow = (
            <div className="offerRow">
              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  setShowOfferModal(true);
                }}
              >
                我要出價
              </Button>
            </div>
          );
        }
      }
    } else {
      /* I own the item */
      let manageItemButton = null;
      if (itemData.status == "normal") {
        manageItemButton = (
          <>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowReserveModal(true);
              }}
              className="offerButton"
            >
              保留物品
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowSoldOutModal(true);
              }}
              className="offerButton"
            >
              物品已售完
            </Button>
          </>
        );
      } else if (itemData.status == "reserved") {
        manageItemButton = (
          <>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowReserveModal(true);
              }}
              className="offerButton"
            >
              取消保留
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowSoldOutModal(true);
              }}
              className="offerButton"
            >
              物品已售完
            </Button>
          </>
        );
      }

      if (currentChatRoom.reviewStatus?.createdUserReviewStatus && currentChatRoom.reviewStatus?.itemOwnerReviewStatus) {
        offerRow = (
          <div>
            <div className="offerButtonRow">{manageItemButton}</div>
            <div className="offerRow">
              <div style={{ color: '#198754', fontSize: '14px', fontWeight: 600 }}>
                已成交及評價
              </div>
            </div>
          </div>
        );
      } else if (currentChatRoom.lastOffer?.offeredStatus == "offered") {
        offerRow = (
          <>
            <b>出價 HK${currentChatRoom.lastOffer?.offeredPrice}</b>&nbsp;
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                setShowAcceptOfferModal(true);
              }}
            >
              接受出價
            </Button>{" "}
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowRejectOfferModal(true);
              }}
            >
              拒絕出價
            </Button>
          </>
        );
      } else if (currentChatRoom.lastOffer?.offeredStatus == "accepted") {
        let reviewButton = null;
        if (currentChatRoom.reviewStatus?.itemOwnerReviewStatus) {
          reviewButton = (
            <div style={{ color: '#198754', fontSize: '14px', fontWeight: 600 }}>
              我已評價
            </div>
          );
        } else {
          /* 30 days write review limit */
          /*
          if (
            Math.floor(Date.now() / 1000) <
            currentChatRoom.lastOffer?.offerUpdatedTime.seconds + 86400 * 30
          ) {
          */
          reviewButton = (
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                setShowWriteReviewModal(true);
              }}
              className="offerButton"
            >
              寫交易評價
            </Button>
          );
          /*
          }
          */
        }
        offerRow = (
          <div>
            <div className="offerButtonRow">{manageItemButton}</div>
            <div className="offerRow">
              {`已成交 HK$${currentChatRoom.lastOffer?.offeredPrice} `}&nbsp;
              {reviewButton}
            </div>
          </div>
        );
      } else if (currentChatRoom.lastOffer?.offeredStatus == "rejected") {
        offerRow = (
          <div>
            <div className="offerButtonRow">{manageItemButton}</div>
            <div className="offerRow">
              {`已拒絕出價 HK$${currentChatRoom.lastOffer?.offeredPrice} `}
              &nbsp;
            </div>
          </div>
        );
      }
    }
  }

  let itemStatusBadge = null;
  if (itemData.status == "soldout") {
    itemStatusBadge = <span className="itemStatusBadge">[已完成]</span>;
  } else if (itemData.status == "soldout") {
    itemStatusBadge = <span className="itemStatusBadge">[已售]</span>;
  } else if (itemData.status == "reserved") {
    itemStatusBadge = <span className="itemStatusBadge">[已保留]</span>;
  }

  let userLineTwo = null;
  if (chatUserData?.suspended) {
    userLineTwo = <div><div className="userSuspended">已被封鎖</div></div>;
  } else {
    let daysAge = null;
    if (chatUserData?.userAge > 0 && chatUserData?.userAge < 86400 * 30) {
      daysAge = (
        <div className="regDays">
          注冊了{parseInt(chatUserData?.userAge / 86400)}日
        </div>
      );
    }
    userLineTwo = (
      <div className="userOnlineStatus">
        {daysAge} {isOnlineText}
      </div>
    );
  }

  let itemImageView = null;
  if (itemData.itemImage != undefined) {
    if (itemData.itemImage != '') {
      itemImageView = <img src={`${imageHost}/media/trade/${itemData.itemImage.toString().replace(".jpg", "_sqt.jpg")}`} className="itemImage" />
    } else {
      itemImageView = <img src={`${imageHost}/trading/images/no_image.png`} className="itemImage" />
    }
  }

  let priceString = null;
  if (itemData.priceAlt == 2) {
    priceString = <div>請洽詢我</div>
  } else {
    if (itemData.newPrice) {
      priceString = <div>HK${itemData.newPrice} <span style={{textDecoration: 'line-through'}}>HK${itemData.price}</span> {itemData.fixedPrice ? <span style={{color: "#666", fontWeight: 'normal', fontSize: '13px'}}>(不議價)</span> : null}</div>;
    } else if (itemData.price) {
      priceString = <div>HK${itemData.price} {itemData.fixedPrice ? <span style={{color: "#666", fontWeight: 'normal', fontSize: '13px'}}>(不議價)</span> : null}</div>;
    }
  }

  return (
    <>
      <div className="messageUser">
        <div
          className="goBackWrap d-lg-none"
          onClick={() => {
            if (parseInt(listItemId) > 0) {
              navigate(`/item/${listItemId}`);
            } else {
              navigate(-1);
            }
          }}
        >
          <i className="bi bi-arrow-left"></i>
          {unReadCounter > 0 ? (
            <div className="unReadCounter">
              {unReadCounter > 9 ? "9+" : unReadCounter}
            </div>
          ) : null}
        </div>
        <a
          href={`https://www.dcfever.com/trading/mycomment.php?id=${chatUserData.uid}`}
          target="_blank"
        >
          <div
            className="
              messageUserRow"
          >
            {chatUserData?.avatar ? (
              <img
                src={
                  chatUserData?.avatar
                    ? webSiteUrl + chatUserData.avatar
                    : ProfilePic
                }
                alt=""
                className="avatar"
              />
            ) : (
              <img
                src="https://cdn01.dcfever.com/column/images/profile_pic.png"
                alt=""
                className="avatar"
              />
            )}
            <div className="userWrap">
              <div
                className={`username ${chatUserData?.suspended ? "suspended" : ""
                  }`}
              >
                {currentMembers?.username
                  ? currentMembers.username
                  : chatUserData?.username}
                {tradingRating}
                {facebookIcon}
                {phoneVerifedIcon}
                {newUserIcon}
                &nbsp;
              </div>
              {userLineTwo}
            </div>
          </div>
        </a>
        <div>
          <ChatRoomDropDown
            targetUserId={currentChatRoom?.members?.find(
              (uid) => uid != currentUser.uid
            )}
            currentChatRoomId={currentChatRoomId}
            chatUserData={chatUserData}
          />
        </div>
      </div>
      <div className="messageItem">
        <div className="messageItemRow">
          <div className="itemImageWrap">
            {itemImageView}
          </div>
          <div className="itemData">
            <a
              href={`https://www.dcfever.com/trading/view.php?itemID=${itemData.itemId}`}
              target="_blank"
            >
              {itemStatusBadge}
              {itemData.type == 2 ? <span className="itemType">徵求</span> : null}
              <span dangerouslySetInnerHTML={{ __html: itemData.itemName }} />
            </a>
            <br />
            <div className="itemPrice">{priceString}</div>
          </div>
        </div>
        {chatRoomMeta.chat_disabled == false && offerRow != null && <div className="messageItemOfferRow">{offerRow}</div>}
      </div >
      <ChatRoomModal
        currentChatRoom={currentChatRoom}
        /* form data */
        offerPrice={offerPrice}
        reviewText={reviewText}
        reviewStar={reviewStar}
        setOfferPrice={setOfferPrice}
        setReviewText={setReviewText}
        setReviewStar={setReviewStar}
        /* actions */
        handleNewOffer={handleNewOffer}
        handleCancelOffer={handleCancelOffer}
        handleRejectOffer={handleRejectOffer}
        handleAcceptOffer={handleAcceptOffer}
        handleWriteReview={handleWriteReview}
        handleReserve={handleReserve}
        handleSoldOut={handleSoldOut}
        /* errors */
        reviewTextError={reviewTextError}
        offerError={offerError}
        /* modals */
        showOfferModal={showOfferModal}
        setShowOfferModal={setShowOfferModal}
        showCancelOfferModal={showCancelOfferModal}
        setShowCancelOfferModal={setShowCancelOfferModal}
        showRejectOfferModal={showRejectOfferModal}
        setShowRejectOfferModal={setShowRejectOfferModal}
        showAcceptOfferModal={showAcceptOfferModal}
        setShowAcceptOfferModal={setShowAcceptOfferModal}
        showWriteReviewModal={showWriteReviewModal}
        setShowWriteReviewModal={setShowWriteReviewModal}
        showReserveModal={showReserveModal}
        setShowReserveModal={setShowReserveModal}
        showSoldOutModal={showSoldOutModal}
        setShowSoldOutModal={setShowSoldOutModal}
      />
      {/* system message dialog */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showDialog}
        onHide={() => {
          setShowDialog(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>系統訊息</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dialogMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowDialog(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>      
    </>
  );
};

export default React.memo(ChatRoomHeader);
